"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var CheckSolid_1 = __importDefault(require("../../icons/Navigation/CheckSolid"));

var Input_1 = __importDefault(require("../Input/Input"));

var Label_1 = __importStar(require("../Label/Label"));
/**
 * Input component <input> - Many different input types
 *
 */


var Checkbox = function Checkbox(_a) {
  var _a$checked = _a.checked,
      checked = _a$checked === void 0 ? false : _a$checked,
      onChange = _a.onChange,
      _a$label = _a.label,
      _label = _a$label === void 0 ? undefined : _a$label,
      _a$position = _a.position,
      position = _a$position === void 0 ? Label_1.Positions.Right : _a$position,
      _a$disabled = _a.disabled,
      disabled = _a$disabled === void 0 ? false : _a$disabled,
      props = __rest(_a, ["checked", "onChange", "label", "position", "disabled"]);

  return react_1["default"].createElement(Input_1["default"], Object.assign({
    type: Input_1["default"].Types.Checkbox,
    label: function label(_a) {
      var rest = __rest(_a, []);

      return react_1["default"].createElement(Label_1["default"], {
        text: _label,
        position: position
      }, react_1["default"].createElement(Input_1["default"], Object.assign({
        type: Input_1["default"].Types.Checkbox,
        checked: checked || undefined,
        onChange: onChange,
        disabled: disabled
      }, rest)), react_1["default"].createElement("span", null, react_1["default"].createElement(CheckSolid_1["default"], null)));
    }
  }, props));
};

exports["default"] = Checkbox;